import React from 'react';
import { logDeprecation } from '../../../util/logging';
// eslint-disable-next-line zillow/import/no-named-default
import { CollapseSVG, default as Collapse } from './IconCollapse';
export var MinimizeSVG = CollapseSVG;
var Minimize = function Minimize(props) {
  logDeprecation("`IconMinimize` has been deprecated, use `IconCollapse`");
  return /*#__PURE__*/React.createElement(Collapse, props);
};
Minimize.displayName = 'IconMinimize';
export default Minimize;